module.exports = __webpack_public_path__ + "static/media/aspirinProtect.3f6a5800.mp3";